import DeleteGenericModal from "../../../modals/DeleteGenericModal";
import ReactTable from "../../../util/ReactTable";
import AsyncBlock from "../../../components/forms/AsyncBlock";
import PageTitle from "../../../components/layout/PageTitle";
import PageSection from "../../../components/layout/PageSection";
import Button from "../../../components/forms/Button";
import PageContainerFull from "../../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../../components/flex/Flex";
import useFetch2 from "../../../hooks/useFetch2";
import {Apis} from "../../../util/data";
import * as React from "react";
import {useParams} from "react-router";
import {useNavigate} from "react-router-dom";
import {PageBackLabel} from "../../../components/layout/PageBackLabel";
import useEditModal from "../../../modals/useEditModal";
import GenericModal2 from "../../../modals/GenericModal2";
import UpdatePonderacion from "../../../components/UpdatePonderacion";

const EnfermedadRiskList = () => {

  const navigate = useNavigate()
  const {id} = useParams()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/riesgo/' + id + '/ponderacion', []);

  const {wrapper: wrapper1, editAction} = useEditModal({
    editComponent: <UpdatePonderacion />,
    onRefresh: fetchData
  });

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' variant='danger' onClick={() => editAction({idEnfermedad: cell.row.original.id, idRiesgo: parseInt(id) ,valor: cell.row.original.valor})}>Cambiar valor</Button>
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Enfermedad',
        accessorKey: 'enfermedad',
      },
      {
        header: 'Valor',
        accessorKey: 'valor',
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageBackLabel text='Riesgos' onClick={() => navigate('/riesgos')}/>
        <PageTitle title={'Enfermedades'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            noData='No existen enfermedades registradas'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <GenericModal2 {...wrapper1} />
    </PageContainerFull>
  )
}

export default EnfermedadRiskList
